module.exports = __webpack_public_path__ + "img/icon_form_security.286db055.svg";